import { encodeVoiceEvent, VOICE_TOPIC } from './voiceProtocol'

export function publishNarration(room, event) {
  if (!room?.localParticipant) return
  const packet = { timestamp_ms: Date.now(), ...event }
  void room.localParticipant
    .publishData(encodeVoiceEvent(packet), { reliable: true, topic: VOICE_TOPIC })
    .catch(() => {})
}
